import { AuthService } from './authService';
export class LocalLLMService {
  static readonly DEFAULT_OLLAMA_URL = 'http://localhost:11434';
  static readonly DEFAULT_LMSTUDIO_URL = 'http://localhost:1234';

  static async checkHealth(url: string, modelId: string, apiKey?: string): Promise<number> {
    const start = performance.now();
    try {
      const response = await AuthService.authFetch(`/local-llm/chat/completions`, {
        method: 'POST',
        headers: Object.fromEntries(AuthService.authHeaders(true).entries()),
        body: JSON.stringify({
          baseUrl: url,
          apiKey,
          model: modelId,
          messages: [{ role: 'user', content: 'ping' }],
          max_tokens: 1
        })
      });
      if (response.ok) {
        return Math.round(performance.now() - start);
      }
    } catch (e) {
      // Fallback for Ollama native API if OpenAI compatibility is not enabled
      try {
        const ollamaResponse = await fetch(`${url}/api/tags`);
        if (ollamaResponse.ok) {
           return Math.round(performance.now() - start);
        }
      } catch (inner) {
        return -1;
      }
    }
    return -1;
  }

  static async fetchLocalModels(url: string, apiKey?: string): Promise<string[]> {
    const result = await this.fetchLocalModelsDetailed(url, apiKey);
    return result.models;
  }

  static async fetchLocalModelsDetailed(url: string, apiKey?: string): Promise<{ models: string[]; error?: string }> {
    try {
      const response = await AuthService.authFetch('/local-llm/models', {
        method: 'POST',
        headers: Object.fromEntries(AuthService.authHeaders(true).entries()),
        body: JSON.stringify({
          baseUrl: url,
          apiKey,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        return {
          models: (data.models || [])
            .filter(Boolean)
        };
      }

      const errorPayload = await response.json().catch(() => null);

      return {
        models: [],
        error: errorPayload?.error || `Geen modellen gevonden op ${url}. Controleer endpoint en provider.`
      };
    } catch (e) {
      return {
        models: [],
        error: `Kan ${url} niet bereiken. Controleer of LM Studio draait en de server aan staat.`
      };
    }
  }

  static async generateText(url: string, prompt: string, context: string, modelId: string, apiKey?: string): Promise<string> {
    try {
      const response = await AuthService.authFetch('/local-llm/chat/completions', {
        method: 'POST',
        headers: Object.fromEntries(AuthService.authHeaders(true).entries()),
        body: JSON.stringify({
          baseUrl: url,
          apiKey,
          model: modelId,
          messages: [
            { role: 'system', content: context },
            { role: 'user', content: prompt }
          ]
        })
      });
      const data = await response.json();
      return data.choices?.[0]?.message?.content || "";
    } catch (error) {
      console.error('Local LLM Error:', error);
      return "Fout bij communicatie met lokale LLM.";
    }
  }
}
